export const initialState = {
  containerId: '' as string,
  isInitialized: false as boolean
};

export type GtmState = Readonly<typeof initialState>;
